import React, { useEffect, useState } from 'react';
import {
  Users, ClipboardList, FileText, FolderLock, MessageSquare, Mail, Newspaper, ArrowRight,
} from 'lucide-react';
import { Link } from 'react-router-dom';
import { adminApi, newsletterApi, postsApi } from '../../lib/api';

export default function AdminOverview() {
  const [stats, setStats] = useState(null);
  const [subCount, setSubCount] = useState(0);
  const [postCount, setPostCount] = useState(0);

  useEffect(() => {
    adminApi.stats().then(setStats).catch(() => {});
    newsletterApi.list().then((s) => setSubCount(s.length)).catch(() => {});
    postsApi.listAdmin().then((p) => setPostCount(p.length)).catch(() => {});
  }, []);

  return (
    <div>
      <div className="mb-6">
        <h2 className="text-xl font-bold text-[#0b1f3a]">Overview</h2>
        <p className="text-slate-500 text-sm mt-1">A snapshot of everything happening on the site.</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <Stat label="Users"     value={stats?.users}     Icon={Users}          to="/admin/users" />
        <Stat label="Quotes"    value={stats?.quotes}    Icon={ClipboardList}  to="/admin/quotes" />
        <Stat label="Policies"  value={stats?.policies}  Icon={FileText}       to="/admin/policies" />
        <Stat label="Documents" value={stats?.documents} Icon={FolderLock} />
        <Stat label="Messages"  value={stats?.messages}  Icon={MessageSquare}  to="/admin/messages" />
        <Stat label="New messages" value={stats?.new_messages} Icon={MessageSquare} accent to="/admin/messages" />
        <Stat label="Subscribers" value={subCount} Icon={Mail}       to="/admin/newsletter" />
        <Stat label="Blog posts"  value={postCount} Icon={Newspaper} to="/admin/blog" />
      </div>

      <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-5">
        <Card title="Edit site content" text="Update hero copy, contact details and footer text." to="/admin/content" />
        <Card title="Manage blog & news" text="Publish and edit articles for the public blog." to="/admin/blog" />
        <Card title="Newsletter subscribers" text="Export and manage newsletter contacts." to="/admin/newsletter" />
        <Card title="SEO settings" text="Page titles, meta descriptions and keywords." to="/admin/seo" />
      </div>
    </div>
  );
}

function Stat({ label, value, Icon, accent, to }) {
  const inner = (
    <div className={`rounded-2xl border p-5 bg-white transition-colors ${accent ? 'border-amber-300' : 'border-slate-200'} ${to ? 'hover:border-[#0d3a8a]/40' : ''}`}>
      <div className="flex items-center gap-2 text-slate-500 text-xs"><Icon size={14} /> {label}</div>
      <p className="text-2xl font-bold text-[#0b1f3a] mt-1">{value ?? '—'}</p>
    </div>
  );
  return to ? <Link to={to}>{inner}</Link> : inner;
}

function Card({ title, text, to }) {
  return (
    <Link to={to} className="bg-white border border-slate-200 rounded-2xl p-6 card-lift block">
      <h3 className="font-semibold text-[#0b1f3a]">{title}</h3>
      <p className="text-sm text-slate-600 mt-1.5">{text}</p>
      <span className="mt-3 inline-flex items-center gap-1 text-sm font-semibold text-[#0d3a8a]">Open <ArrowRight size={14} /></span>
    </Link>
  );
}
